import { useEffect } from 'react';

import { clearBrazeSession, initializeBraze } from 'utils/brazeUtils';

/**
 * Manages Braze Web SDK session for authenticated users.
 * Initializes and opens a session when customerID is present; clears when it is absent
 * (covers sign-out paths that do not go through /logout).
 * Logout also clears before its hard redirect so wipeData runs before unload.
 * No-op in the native app webview (native already uses Braze for in-app messaging).
 *
 * @param {string|number|undefined|null} customerID - Logged-in customer ID from account
 */
export default function useBraze(customerID) {
    useEffect(() => {
        if (window.isNativeApp) {
            return;
        }

        if (!customerID) {
            clearBrazeSession();
            return;
        }

        if (!window.braze) {
            initializeBraze();
        }
        if (window.braze) {
            window.braze.changeUser(customerID.toString());
            window.braze.openSession();
        }
    }, [customerID]);
}
